import { createSlice } from "@reduxjs/toolkit"
import {
  cancelInterview,
  getAvailableSlots,
  getJobApplication,
  getJobApplicationDetails,
  getJobApplicationTimeline,
  interviewApply,
  verifyActionOtp,
  withdrawnJobApplication,
} from "store/actions/jobApplicationAction"

const initialState = {
  loading: false,
  isLoading: false,
  jobApplication: [],
  jobApplicationDetails: {},
  availableSlots: [],
  timeLine: [],
  enabled_withdrawn_action: null,
}

const usersSlice = createSlice({
  name: "job", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getJobApplication.pending, state => {
        state.loading = true
      })
      .addCase(getJobApplication.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.jobApplication = data
        }
      })
      .addCase(getJobApplication.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getJobApplicationDetails.pending, state => {
        state.loading = true
        state.jobApplicationDetails = {}
      })
      .addCase(getJobApplicationDetails.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          console.log(data)
          state.jobApplicationDetails = data
        }
      })
      .addCase(getJobApplicationDetails.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getAvailableSlots.pending, state => {
        state.loading = true
        state.jobApplicationDetails = {}
      })
      .addCase(getAvailableSlots.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          state.availableSlots = data
        }
      })
      .addCase(getAvailableSlots.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(interviewApply.pending, state => {
        state.isLoading = true
      })
      .addCase(interviewApply.fulfilled, (state, action) => {
        state.isLoading = false
        const { uuid } = action.meta.arg

        const { success, data } = action.payload
        if (success) {
          //   state.availableSlots = state.availableSlots.filter(
          //     item => item.uuid !== uuid
          //   )
        }
      })
      .addCase(interviewApply.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(cancelInterview.pending, state => {
        state.isLoading = true
      })
      .addCase(cancelInterview.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(cancelInterview.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(withdrawnJobApplication.pending, state => {
        state.isLoading = true
      })
      .addCase(withdrawnJobApplication.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(withdrawnJobApplication.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getJobApplicationTimeline.pending, state => {
        state.loading = true
      })
      .addCase(getJobApplicationTimeline.fulfilled, (state, action) => {
        state.loading = false
        const { success, data, application_actions } = action.payload
        if (success) {
          const { enabled_withdrawn_action } = application_actions || {}
          state.enabled_withdrawn_action = enabled_withdrawn_action
          //   console.log(data)
          state.timeLine = data
        }
      })
      .addCase(getJobApplicationTimeline.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(verifyActionOtp.pending, state => {
        state.isLoading = true
      })
      .addCase(verifyActionOtp.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(verifyActionOtp.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
